module.exports = __webpack_public_path__ + "static/media/500022.8ea87a70.svg";